import styled from 'styled-components';

const EmptyTableWrapper = styled.tbody`
  display: flex;
  flex-direction: column;
  tr.empty{
    .td-empty{
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 3rem;
      img {
        width: 150px;
        margin-bottom: 2rem;
      }
      .word-empty{
        font-size: 1rem;
        text-align: center;
        line-height: 18px;
      }
    }
  }
  @media only screen and (max-width : 480px) {
    tr.empty{
      .td-empty{
        .word-empty{
          font-size: .75rem;
        }
      }
    }
  }
`

export default EmptyTableWrapper;